module.exports = __webpack_public_path__ + "static/media/backIcon.9bd1ef85.svg";